import gql from 'graphql-tag'

export const requestInviteCount = gql`
  query requestInviteCount($workspace_id: Float!) {
    requestInviteCount(workspace_id: $workspace_id)
  }
`
